/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { PidxLoaderModule, PidxSkeletonLoaderModule } from '@myprofile-ui/pidx-ui-components'
import { MyProfilePreferredLanguageWidgetComponent } from './myprofile-preferred-language-widget.component'
import { RESTRICT_GLOBAL_UI_CHANGES } from '../../../pidx-utils/src/lib/helpers/restrictGlobalUIChanges.injectionToken'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'

@NgModule({
  imports: [CommonModule, PidxLoaderModule, PidxSkeletonLoaderModule, ReactiveFormsModule, PorscheDesignSystemModule],
  declarations: [MyProfilePreferredLanguageWidgetComponent],
  exports: [MyProfilePreferredLanguageWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyProfilePreferredLanguageWidgetModule {
  static forRoot(restrictGlobalUIChanges: boolean): ModuleWithProviders<MyProfilePreferredLanguageWidgetModule> {
    return {
      ngModule: MyProfilePreferredLanguageWidgetModule,
      providers: [{ provide: RESTRICT_GLOBAL_UI_CHANGES, useValue: restrictGlobalUIChanges }],
    }
  }
}
